<template>
	<div class="cashoutreconciliation">
		<div class="top">
			<el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>     
            <el-date-picker
                v-model="pagination.billdateformat"  :clearable="false" size="medium"
                type="month"
                placeholder="选择月" @change="querySummaryList()">
            </el-date-picker>      
        </div>
		<div>
			<el-table :height="windowHeight - 210" :data="dataList" style="width: 100%" border>	
				<el-table-column label="日期" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.billdateformat }}
					</template>
				</el-table-column>
				<el-table-column label="平台商户名称" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>
							{{ scope.row.merName }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="清分笔数" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.tradeCount }}
						</span>
					</template>
				</el-table-column>
                <el-table-column label="清分金额(元)" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.tradeFeeCount }}
						</span>
					</template>
				</el-table-column>
                  <el-table-column align="center" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                         <el-tag  size="mini" type="danger" v-if="scope.row.settled">已对账</el-tag>
                        <el-tag  size="mini" type="success" v-if="!scope.row.settled">未对账</el-tag>
                    </template>
                </el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-if="!scope.row.settled" @click="updateBilltransfer(scope.row.billdateformat)">发起对账</el-button>
						<el-button type="text" size="small" v-if="scope.row.settled" @click="cashoutreconciliationinfo(scope.row.billdateformat)">查看明细</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>

import windowResize from '@/mixins/windowResize'
import baseMixin from '@/mixins/baseMixin'
import {querySummaryList,updateBilltransfer} from '@/api/platformmerchant'

export default {
	name: 'subjectList',
	data() {
		return {
			pagination: {
                merId:this.$route.query.merId,
                billdateformat:new Date(),
			},
			dataList: []
		}
	},
	created() {
        this.querySummaryList();   
	},
	mixins: [windowResize, baseMixin],
	methods: {
          updateBilltransfer(billdateformat) {
			this.$confirm('是否发起对账?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					updateBilltransfer({
                         merId:this.$route.query.merId,
                        billdateformat:billdateformat
                    }).then(res => {
						this.querySummaryList()
						this.$message({
							type: 'success',
							message: '发起对账成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消发起对账'
					})
				})
		},	
     querySummaryList() {
         this.pagination.billdateformat=this.$moment(this.pagination.billdateformat).format("YYYY-MM")
		 querySummaryList(this.pagination)
        .then(res => res.data)
        .then(data => {
          this.dataList = data.data;
        });
		},   
		cashoutreconciliationinfo(billdateformat){
           this.$router.push({path:'cashoutreconciliationinfo',query:{
			   merId:this.$route.query.merId,
               billdateformat:billdateformat
		   }});
        }		
	}
}
</script>
<style lang="scss" scoped>
.cashoutreconciliation {
	padding: 12px;
	.pagination-container {
		margin-top: 10px;
	}
	.top {
		padding-bottom: 10px;
		overflow: hidden;
	}
	a,
	.link {
		color: #409eff;
		cursor: pointer;
	}
	.state-container {
		margin: 15px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/platformmerchant/cashoutreconciliation.vue